import React, { useEffect, useContext, useState } from 'react'
import { Link as RouterLink, useHistory } from 'react-router-dom';

import Moment from 'moment'

import LanguageContext from "../../../contexts/LanguageContext"

import { Box, Hidden } from '@mui/material'

import cardIcon from "../../../images/cardIcon.svg"
import noSoftSkillsViewerIcon from "../../../images/noSoftSkillsViewerIcon.svg"


import './SoftSkillsViewer.css'


Moment.locale('fr')

const AdminDashboardNavBar = (props, context) => {

  const { actLanguage, languageValues } = useContext(LanguageContext)

  const [slides, setSlides] = useState([]);
  // A4 review 02/09 : une famille a la fois, navigation par points (carousel)
  const [slideActive, setSlideActive] = useState(0)

  useEffect(() => {
    let efficacite = props.softSkills.filter((el) => el.family === 'efficacite')
    let communication = props.softSkills.filter((el) => el.family === 'communication')
    let leadership = props.softSkills.filter((el) => el.family === 'leadership')

    let newSlides = []
    if (efficacite.length > 0) {
      newSlides.push({
        title : languageValues?.adminDashboard?.efficaciteSkills[actLanguage],
        softSkills : efficacite,
        family : 'efficacite'
      })
    }
    if (communication.length > 0) {
      newSlides.push({
        title : languageValues?.adminDashboard?.communicationSkills[actLanguage],
        softSkills : communication,
        family : 'communication'
      })
    }
    if (leadership.length > 0) {
      newSlides.push({
        title : languageValues?.adminDashboard?.leadershipSkills[actLanguage],
        softSkills : leadership,
        family : 'leadership'
      })
    }

    setSlides(newSlides)
    setSlideActive(0)
  }, [props.softSkills])

  // Historique : le point 9 du 04/08 avait empile toutes les familles ;
  // le point A4 du 02/09 revient a une famille par vue, mais en grille
  // 2 colonnes avec carousel, conformement au Figma.
  // La casse vient de la donnee : « premiere lettre en majuscule » uniquement,
  // au lieu du textTransform capitalize qui majusculait chaque mot
  // (« Influence Assertive » au lieu de « Influence assertive »).
  const casePhrase = (s) => {
    const txt = String(s == null ? '' : s).trim()
    if (!txt) return ''
    return txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase()
  }

  return (
    <>
      {(props.dataLoaded === true && props.softSkills.length > 0 && slides.length > 0) ? (
        <>
          {/* F3 (retours Hicham 03/09) : ce titre doit etre lu comme le titre de
              la carte de gauche (« Suivi des participants », Questrial 23 px noir),
              et non comme une legende grise plus petite. Meme police partout dans
              l'application, seules la taille et la couleur differaient. */}
          <Box sx={{marginBottom:["12px", "14px"]}}>
            <Box sx={{color:"text.black", fontSize:["20px", "22px", "22px", "23px"], lineHeight:1.2}}>
              {languageValues?.adminDashboard?.usedSoftSkills[actLanguage]}
            </Box>
          </Box>
          {/* A4 review 02/09 (conforme Figma) : UNE famille a la fois, grille a
              2 colonnes, pagination en carousel (points en bas). L'affichage
              vertical de toutes les familles empilees etait juge illisible. */}
          <Box sx={{flex:1, overflowY:"auto", display:"flex", flexDirection:"column", paddingRight:"4px"}}>
            {slides[slideActive] &&
              <Box key={slides[slideActive].family}>
                {/* F4 : la famille gagne un cran de taille, pour se detacher de la
                    liste des competences qu'elle coiffe. */}
                <Box sx={{
                  color:"text.subTitle",
                  fontSize:["15px","16px","16px","17px"],
                  marginBottom:["16px", "18px"],
                }}>
                  {slides[slideActive].title}
                </Box>
                {/* F2 : disposition reprise du schema de reference — deux colonnes
                    largement espacees, pastille carree bordee devant chaque
                    competence, nom en noir sur une ligne. L'ancienne grille etait
                    trop serree et les noms se coupaient. */}
                <Box sx={{
                  display:"grid",
                  gridTemplateColumns:"1fr 1fr",
                  columnGap:["16px", "24px", "24px", "30px"],
                  rowGap:["16px", "20px", "20px", "24px"],
                }}>
                  {slides[slideActive].softSkills.map((skill, i2) => (
                    <Box key={i2} sx={{display:"flex", alignItems:"center", gap:["10px", "14px"], minWidth:0}}>
                      <Box sx={{
                        width:["32px", "34px", "34px", "40px"],
                        minWidth:["32px", "34px", "34px", "40px"],
                        height:["32px", "34px", "34px", "40px"],
                        border:"1px solid #E7E7E7",
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"center",
                        flexShrink:0,
                      }}>
                        <img src={cardIcon} style={{width:"62%"}} alt=""/>
                      </Box>
                      <Box sx={{
                        color:"text.black",
                        fontSize:["15px","16px","16px","17px"],
                        whiteSpace:"nowrap",
                        overflow:"hidden",
                        textOverflow:"ellipsis",
                      }} title={casePhrase(skill.key)}>
                        {casePhrase(skill.key)}
                      </Box>
                    </Box>
                  ))}
                </Box>
              </Box>
            }
          </Box>
          {slides.length > 1 &&
            <Box sx={{display:"flex", justifyContent:"center", gap:"8px", paddingTop:"10px"}}>
              {slides.map((groupe, i) => (
                <Box
                  key={i}
                  onClick={() => { setSlideActive(i) }}
                  // F2 : reperes en barres courtes, comme le schema de reference
                  sx={{
                    width:"22px", height:"3px", borderRadius:"2px",
                    cursor:"pointer",
                    background: i === slideActive ? "#0A0A0B" : "#D8D3CE",
                    transition:"background 0.3s ease",
                  }}
                />
              ))}
            </Box>
          }
        </>
      ) : (
        <Box sx={{flex:1, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:"15px", paddingBottom:["15px", "0px"]}}>
          <Box sx={{
            width:["50px", "60px", "60px", "75px"],
            minWidth:["50px", "60px", "60px", "75px"],
          }}>
            <img src={noSoftSkillsViewerIcon} style={{width:"100%"}} alt=""/>
          </Box>
          <Box sx={{
            color:"text.black",
            fontSize:["20px", "24px", "24px", "26px"],
            textAlign:"center",
          }}>
            {languageValues?.adminDashboard?.softSkillsViewer?.emptyTitle[actLanguage]}
          </Box>
          <Box sx={{
            color:"text.subTitle",
            fontSize:["15px", "16px", "16px", "17px"],
            textAlign:"center",
            maxWidth:"300px",
          }}>
            {languageValues?.adminDashboard?.softSkillsViewer?.emptySubTitle[actLanguage]}
          </Box>
        </Box>
      )}
    </>
  )
}


export default AdminDashboardNavBar
